import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager} from "../../AudioManager";
import { Rect } from "../.././MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FontResource } from "../../ResourceManager/FontResource";

// namespace SlotGames
// {

	export class SecretsOfAnubis_2Screen extends SlotGameType1_2Screen {

        //protected panelFactory:IPanelFactory = new SecretsOfAnubisPanelFactory();
		protected override helpFactory:IHelpFactory = new SecretsOfAnubisHelpFactory();
        

        //LED COLOR
		protected override ColorLed:string="205,164,52\n";
        
		
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "SecretsOfAnubis");
			this.spinnableReelsParams.topBorderWidth = 0;
			this.spinnableReelsParams.bottomBorderWidth = 0;
		
        }
        
        //SEND COLOR FOR SRA
    protected override color: RewardColor =
    {
        color: "#F9F8E2",
        coloroutherStroke: "#260D04",
        colorinnerStroke: "#703716"
    }

		
    }
    

	
// }

//Panel Colorized merged
class SecretsOfAnubisPanelFactory implements IPanelFactory
{
    public CreateNewPanel(params: PanelParams):Panel
    {
        return new SecretsOfAnubisPanel(params);
    }
}

class SecretsOfAnubisPanel extends Panel
	{
		protected override ButtonBackground():ButtonColors
		{
			let color:ButtonColors ={
				backgroundButtonColor: "linear-gradient(rgb(38, 13, 4),rgb(64, 30, 10), rgb(112, 55, 22),rgb(64, 30, 10),rgb(38, 13, 4)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				linearColor:"linear-gradient(to left , transparent, rgb(191, 83, 21),transparent ) 0 10 100%",
			};
			
			return color;
		}
	}
    class SecretsOfAnubisHelpFactory implements IHelpFactory
    {
        public CreateNewHelp(params: HelpParameters):Help
        {
            return new  SecretsOfAnubisHelp(params);
        }
    }
    
    class SecretsOfAnubisHelp extends Help
    {
        protected override BackgroundPanel():HelpPanelColor
        {
            let color:HelpPanelColor = {
                backgroundPanelColor:  "linear-gradient(rgb(64, 10, 5),rgb(89, 23, 8), rgb(140, 52, 20),rgb(89, 23, 8),rgb(64, 10, 5)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };
    
            return color;
        }
    }